export default "__VITE_ASSET__DKUbzhwi__"